/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// material
import { Title } from '@insticator/insticator-ui'; // iui-material
import ExportBox from 'material/exportbox/exportbox';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/commenting/export/export_styles';
// actions
import { exportCommentingAnalytics } from 'state/actions/commentingState/exportStatus';

/* ========== ~~~~~~~~~~ COMMENTING EXPORT ~~~~~~~~~~ ========== */
const Export = (props) => {
    const commentingUnitUUID = useSelector(({commentingState}) => commentingState.configStatus.commentingUnitUUID);
    const fileProcessing = useSelector(({commentingState}) => commentingState.exportStatus.isExporting);
    const [fileType, setFileType] = useState(null);
    const dispatch = useDispatch();

    useEffect(() => {
        if (fileType !== null) {
            dispatch(exportCommentingAnalytics(commentingUnitUUID, fileType, setFileType(null)));
        }
    }, [fileType]);

    const csvMessages = [
        `Comma Separated Values (CSV) is a format that stores table and spreadsheet information. 
        The content is text, numbers, and dates in plain text. 
        Each line represents a row of the table, and commas separate the cells in a row.`,
        'CSV files can be opened by any spreadsheet program: Microsoft Excel, Open Office, Google Spreadsheets, etc. You can open a CSV file in a simple text editor as well.'
    ];
    const xmlMessages = [
        `Extensible Markup Language (XML) is a format that stores and describes information in plain text with custom tags. XML files are reader-friendly, with a clear focus on use and exchange on the Internet and on corporate networks.`,
        'XML files can be opened by any web browser for viewing structured data or by Notepad for editing.'
    ];
    const applyTipMessages = (messages) => {
        return (
            <div className={'csvToolTip'}>
                <span>{messages[0]}</span>
                <br /><br />
                <span>{messages[1]}</span>
            </div>
        );
    }

    return(
        <div className={`export ${props.classes.export}`}>
            <div className={'header'}>
                <Title><h3>Export user data as a CSV or XML</h3></Title>
                <p>Export includes <strong>user profile data</strong> (name, email, location) and <strong>user activity data</strong> (sign-up date, last login, etc.).</p>
            </div>
            <ExportBox image={'illustration-csv.png'} title={'Comma Separated Values'} value={`CSV`}
                subdescription={'Tabular format (Microsoft Excel, Google Spreadsheets, etc.).'} 
                buttontext={'Export as CSV'} 
                selected={fileType}
                processing={fileProcessing && fileType === 'CSV'}
                tipcontent={applyTipMessages(csvMessages)}
                handleExport={setFileType}/>
            <ExportBox image={'illustration-xml.png'} title={'Extensible Markup Language'} value={`XML`}
                subdescription={'Internet format (Web browsers, Notepad, etc.).'} 
                buttontext={'Export as XML'} 
                selected={fileType}
                processing={fileProcessing && fileType === 'XML'}
                tipcontent={applyTipMessages(xmlMessages)}
                handleExport={setFileType}/>
        </div>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Export);
